export default __webpack_public_path__ + "static/media/whyUsBg.b2b1597b.png";